import {useIntl} from '@sail/intl';
import {getStore} from 'src/v2/state/store';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Text} from 'src/v2/components/common/Text';
import {LinkTitleWrapper} from 'src/v2/components/screen/link/LinkTitleWrapper';

const messages = defineMessages({
  title: {
    id: 'crypto.payins.v2.heading.pay_title',
    description: 'Header for the payment screen',
    defaultMessage: 'Pay {businessName}',
  },
});

export const PayTitle = () => {
  const store = getStore();
  const intl = useIntl();

  const businessName = store.useSelector(
    (state) => state.merchantBranding.businessName,
  );

  const depositAmount = store.useSelector(
    (state) => state.paymentDetails.amount,
  );
  const currency = store.useSelector((state) => state.paymentDetails.currency);
  const originalAmount = store.useSelector(
    (state) => state.paymentDetails.originalAmount,
  );
  const originalCurrency = store.useSelector(
    (state) => state.paymentDetails.originalCurrency,
  );

  // Using symbol-narrow to avoid showing an explicit currency name like USD, USDC, USDT, etc.
  const formattedDepositAmount = intl.formatCurrency(depositAmount, {
    currency,
    style: 'symbol-narrow',
  });

  let formattedOriginalAmount = null;
  if (originalAmount !== null && originalCurrency !== null) {
    // Using symbol style so there's no ambiguity about the currency. i.e. MX$100 vs $100
    formattedOriginalAmount = intl.formatCurrency(originalAmount, {
      currency: originalCurrency,
      style: 'symbol',
    });
  }

  return (
    <LinkTitleWrapper>
      <Text type="headline">
        <FormattedMessage {...messages.title} values={{businessName}} />
      </Text>

      <Text type="heading">
        {formattedOriginalAmount !== null
          ? `${formattedOriginalAmount} → ${formattedDepositAmount}`
          : formattedDepositAmount}
      </Text>
    </LinkTitleWrapper>
  );
};
